import { useBasisTheoryToken } from 'common/hooks/use-basis-theory-token';

/**
 * Turns the current form's payment-method selection into the Basis Theory token
 * the backend detokenizes into Stripe. Card → BT card token; ACH → BT bank token.
 * Mirrors the checkout-form token flow so raw PANs/account numbers never leave the
 * Basis Theory elements. (#33155)
 */
export const useSweepPaymentToken = () => {
  const { getBasisTheoryCCToken, getBasisTheoryACHToken } = useBasisTheoryToken();

  return async (paymentMethodType) => {
    if (paymentMethodType === 'us_bank_account') {
      const { id } = await getBasisTheoryACHToken();
      return { paymentMethodToken: id, paymentMethodType };
    }
    const { token } = await getBasisTheoryCCToken();
    return { paymentMethodToken: token, paymentMethodType };
  };
};
